export default {
  searchRoutePrefix: '/data/',
  routeByKind: {
    company: 'company',
    person: 'person',
    association: 'association',
    project: 'project',
  },
}
